import { DataBaseModelInterface } from '@solcre-org/core';
import { PortOvertimeLevel } from '../enums/port-overtime-level.enum';

export class PortOvertimeRuleModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public port?: string,
    public level?: PortOvertimeLevel | string,
    public daysOfWeek: number[] = [],
    public startTime?: string,
    public endTime?: string
  ) {}

  public fromJSON(json: any): PortOvertimeRuleModel {
    if (json) {
      this.id = json.id;
      this.port = this.extractPortIri(json.port);
      this.level = json.level;
      this.daysOfWeek = Array.isArray(json.daysOfWeek) ? [...json.daysOfWeek].map(Number) : [];
      this.startTime = json.startTime;
      this.endTime = json.endTime;
    }

    return this;
  }

  public fromJSONList(json: any): PortOvertimeRuleModel[] {
    if (json) {
      return json.map((element: any) => new PortOvertimeRuleModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      port: this.port,
      level: this.level,
      daysOfWeek: this.daysOfWeek,
      startTime: this.startTime,
      endTime: this.endTime,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }

  // Crosses midnight when the window wraps past 00:00 (e.g. 19:00–07:00).
  public crossesMidnight(): boolean {
    if (!this.startTime || !this.endTime) {
      return false;
    }

    return this.endTime <= this.startTime;
  }

  private extractPortIri(value: any): string | undefined {
    if (!value) {
      return undefined;
    }

    if (typeof value === 'string') {
      return value;
    }

    const reference = value['@id'] ?? value.id;
    if (typeof reference === 'string' && reference.startsWith('/api/')) {
      return reference;
    }

    return reference ? `/api/ports/${reference}` : undefined;
  }
}
